module.exports = __webpack_public_path__ + "08_hige_black.eb734279.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/08_hige_black.png
// module id = T4dH
// module chunks = 0